export const SET_CONTACT: string = 'SET_CONTACT';
export const SET_CONTACT_ERRORS: string = 'SET_CONTACT_ERRORS';
export const SET_CONTACT_TOUCHED: string = 'SET_CONTACT_TOUCHED';
export const IS_SENT_SUCCESSFULLY: string = 'IS_SENT_SUCCESSFULLY';
export const IS_SENT_UNSUCCESSFULLY: string = 'IS_SENT_UNSUCCESSFULLY';
export const RESET_CONTACT: string = 'RESET_CONTACT';
